import Vue from 'vue';

export default class telGroupItem {
    constructor(options) {
        this.cache(options)
        this.init()
    }
    cache(options) {
        const opt = options.settings || options
        this.settings = Vue.observable({
            ...this.defaults,
            ...opt
        });
        return this
    }
    get defaults() {
        return {
            user_id: null,
            user_name: null,
            status: null,
            color: null,
            status_value: null,
            has_incoming: false
        }
    }
    get id() {
        return this.settings.user_id
    }
    get name() {
        return this.settings.user_name
    }
    get status() {
        return this.settings.status
    }

    get status_value() {
        return this.settings.status_value
    }

    set status(value) {
        this.settings.status = value
    }

    get agent_id() {
        return this.settings.agent_id
    }
    
    set(options) {
        this.settings = {
            ...this.settings,
            ...options
        }
    }

    get color() {
        return this.settings.color
    }
    set color(value) {
        this.settings.color = value
    }
    set has_incoming(value) {
        this.settings.has_incoming = value
    }
    get has_incoming() {
        return this.settings.has_incoming
    }
    init() {
        return this
    }
}